require('./billingInfoService');
require('../../shared/countryListService');
require('../../fhApp/currentUser/currentUser');
require('../purchasePlanService');

"use strict";

angular.module('app.purchase.billingInfo.billingInfoController', [
  'app.purchase.billingInfo.billingInfoService',
  'app.shared.countryListService',
  'app.currentUser',
  'app.purchase.purchasePlanService'
])
  .controller('app.purchase.billingInfo.billingInfoController', [
    '$scope',
    '$stateParams',
    'app.purchase.billingInfo.billingInfoService',
    'app.shared.countryListService',
    'currentUser',
    '$state',
    '$q',
    'app.purchase.purchasePlanService',
    '$uibModal',
    function ($scope, $stateParams, billingInfo, countryList, currentUser, $state, $q, purchasePlan, $uibModal) {
      $scope.countries = countryList.countries;

      $scope.currentUser = currentUser;
      $scope.state = $state;

      $scope.plan = $stateParams.plan;
      $scope.team = $stateParams.team;
      $scope.upgrade = $stateParams.upgrade;
      $scope.uuid = $stateParams.uuid;

      $scope.billingInfo = billingInfo;

      $scope.selectedCurrency = $scope.plan ? $scope.plan.currency : null;
      $scope.hasError = {};
      $scope.billing_error_message = null;
      $scope.submitted = false;
      $scope.purchasing_plan = false;

      let billingModal = null;

      $scope.months = [];
      for (let i = 0; i < 12; i++) {
        $scope.months.push({
          number: i + 1,
          name: moment().month(i).format('MMMM')
        });
      }

      $scope.years = [];
      for (let i = 0; i < 20; i++) {
        $scope.years.push(moment().year() + i);
      }

      let init = function () {
        billingInfo.retrieve();

        if ($scope.plan) {
          $scope.purchasing_plan = true;
        }

        if ($scope.upgrade && !$scope.uuid) {
          alert("The id of the subscription to upgrade is missing. Please try again.");
          $state.go('app.pricing', null, { inherit: false, reload: true });
        }
      };

      let modalOpen = function () {
        billingModal = $uibModal.open({
          templateUrl: 'billing-info-modal-id.html',
          backdrop: 'static',
          windowClass: 'billing-info-modal',
          backdropClass: 'billing-info-modal-backdrop',
        });
      };

      let modalCancel = function () {
        if (billingModal) {
          window.setTimeout(function () {
            billingModal.close();
          }, 1000);
        }
      };

      /*$scope.changeCurrency = (args) => {
        billingInfo.getPlan($scope.plan.plan_code, args)
          .then((response) => {
            let data = response.data;

            if (data.error) {
              alert(data.error);
            }
            else if (data.plan) {
              $scope.plan = data.plan;
            }
            else {
              alert('Failed to retrieve plan.');
            }
          })
      };*/

      $scope.saveBilling = () => {
        modalOpen();
        $scope.submitted = true;
        // We have received errors after enabling the Avalara plugin in Recurly for
        // users that enter "Québec" (with the accent on the e) as part of their address.
        // Passing over "QC" will just "Quebec" will avoid the error.
        if (billingInfo.data.state.trim().toLowerCase() === "québec") {
          billingInfo.data.state = "QC";
        }

        billingInfo.validate(document.getElementById('billing_form'))
          .then((token) => {
            if ($scope.plan) {
              purchasePlan.purchase($scope.plan, token, $scope.team, $scope.upgrade, $scope.uuid)
                .then(
                  (data) => {
                    modalCancel();
                    if (data.error) {
                      $scope.billing_error_message = data.error;
                    } else {
                      currentUser.get_current_subscriptions('recurly').then(() => {
                        currentUser.update();
                        $state.go('app.pricing', {});
                      });
                    }
                  },
                  (response) => {
                    let data = response.data;

                    modalCancel();
                    if (data.error) {
                      $scope.billing_error_message = data.error;
                    } else {
                      $scope.billing_error_message = 'Failed to validate billing information.';
                    }
                  }
                );
            }
            else {
              billingInfo.save(token)
                .then(function (result) {
                  modalCancel();
                  currentUser.update();
                  if (result.data.error) {
                    $state.go('app.purchase.results', { result: 'error', message: result.data.error });
                  } else {
                    if ($scope.billing_error_message !== null) {
                      $scope.billing_error_message = null;
                    }

                    $state.go('app.purchase.results', { result: 'success' });
                  }
                });
            }
          },
            /**
             * @param {{fields: Array}} err
             */
            (err) => {
              modalCancel();
              $scope.hasError = {};
              $scope.billing_error_message = err.message + ' (' + err.fields.join(', ') + ')';

              angular.forEach(err.fields, function (field) {
                $scope.hasError[field] = { error: true };
              });
            }
          )
      };

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/purchase/billingInfo/billingInfoController.js